import styled from "styled-components";
import { palette } from "@interia/common/styles/global";
import { up, down } from 'styled-breakpoints';
import { P } from "@interia/common/components/typography";
import { Section } from "@interia/common/components/section";


export const Wrapper = styled(Section)`
  color: ${palette.text.black};
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
`


